var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-dialog',{staticClass:"mall-dialog-player",class:{
  'mall-dialog-audio': _vm.theme == 'audio',
  'mall-dialog-video': _vm.theme == 'video',
  'fullscreen': _vm.fullscreen
},attrs:{"show-confirm-button":false},on:{"close":_vm.close},model:{value:(_vm.showPlayer),callback:function ($$v) {_vm.showPlayer=$$v},expression:"showPlayer"}},[_c('div',{staticClass:"inner"},[_c('mall-player',{ref:"player",attrs:{"theme":_vm.theme,"src":_vm.src}}),_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){_vm.showPlayer = false}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }